import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { AI_MODEL, TEXT_PROCESS_TASK } from '@makyoapp/makyo-common'
import { Chip, SelectDropdown } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { ColumnDd } from './ColumnDd'
import { Fld, Lbl } from './shared'

/**
 * handle task field for AITextProcessing column type
 */
function FieldTask() {
  const { id, value, setValue } = useCreateColumnContext()
  return (
    <Fld>
      <Lbl>
        <Trans>Meta Tags</Trans>
      </Lbl>
      {TEXT_PROCESS_TASK.map((task) => {
        let label
        switch (task) {
          case 'simplify':
            label = 'Simplify'
            break
          case 'correct grammar':
            label = 'Correct Grammar'
            break
          case 'summarize':
            label = 'Summarize'
            break
        }

        return (
          <Chip
            id={`${id}-text-ai-task-${task}`}
            key={task}
            active={value.textProcOptions.textProcTask === task}
            onClick={() =>
              setValue({
                textProcOptions: {
                  ...value.textProcOptions,
                  textProcTask: task,
                },
              })
            }
          >
            <Trans>{label}</Trans>
          </Chip>
        )
      })}
    </Fld>
  )
}

/**
 * handle AI model field for AITextProcessing column type
 */
function FieldModel() {
  const { id, value, setValue } = useCreateColumnContext()

  return (
    <Fld>
      <Lbl>
        <Trans>AI Model</Trans>
      </Lbl>
      <SelectDropdown
        id={`${id}-text-ai-model`}
        menuDefaultSize={false}
        menuClassName={'max-h-[220px] overflow-y-auto'}
        menuContainerClassName='mk-ag-sdd'
        menuZIndex='z-305'
        withSearch
        portalMenu
        onChange={(opt) => {
          setValue({
            textProcOptions: {
              ...value.textProcOptions,
              textProcModel: opt,
            },
          })
        }}
        value={value.textProcOptions.textProcModel}
        options={AI_MODEL}
      />
    </Fld>
  )
}

/**
 * handle text source column for AITextProcessing column type
 */
function FieldTextColumn() {
  const { id, value, setValue } = useCreateColumnContext()
  const selected = value.textProcOptions.textProcColumn
  const { t } = useTranslation()

  return (
    <Fld>
      <Lbl>
        <Trans>Text Column</Trans>
      </Lbl>
      <ColumnDd
        id={`${id}-text-ai-column`}
        placeholder={t('Select Column')}
        types={[ColumnTypes.RichText, ColumnTypes.Text]}
        selected={selected}
        onChange={(opt) => {
          setValue({
            textProcOptions: {
              ...value.textProcOptions,
              textProcColumn: opt.id,
            },
          })
        }}
      />
    </Fld>
  )
}

/**
 * handle all fields for text ai processing
 */
export default function FieldTextAI() {
  return (
    <>
      <FieldTask />
      <FieldTextColumn />
      <FieldModel />
    </>
  )
}
